export enum CpxCardTypeEnum {
  'CPS' = 1,        // Carte de Professionnel de Santé
  'CPF' = 2,        // Carte de Professionnel de santé en Formation
  'CPE' = 3,        // Carte de Personnel d'Etablissement (CDE, CPE)
  'CPA' = 4,        //  Carte de Personnel Administratif (CPA, CDA)
}
